export const blockIconsPrivacyandsecuritySecurityNew = (
	<span className='material-symbols-outlined'>security</span>
);
